<template>
	<div class="section">
		<div class="container is-large">
			<div class="section-body">
				<div class="section-left">
					<router-link
						class="section-description is-medium"
						:to="{ name: 'DataProtection' }"
					>
						Data protection
					</router-link>
					<router-link
						class="section-description is-medium"
						:to="{ name: 'Imprint' }"
					>
						Imprint
					</router-link>
				</div>
				<div class="section-right">
					<router-view />
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'Legal',
};
</script>

<style lang="scss" scoped>
.section {
	background-color: $color-black;
	color: $color-white;

	.section-subtitle {
		color: $color-accent-200;
		margin-top: $gap-4;
	}

	.section-description {
		color: $color-accent-300;
		font-weight: $fontWeight-regular;
		padding: $gap-2;
		cursor: pointer;

		&.router-link-exact-active {
			color: $color-accent-100;
			background-color: $color-accent-600;
		}

		&:not(:first-child) {
			border-top: 1px solid $color-accent-400;
		}

		&:first-child {
			border-radius: 3px 3px 0 0;
		}

		&:last-child {
			border-radius: 0 0 3px 3px;
		}
	}

	.section-body {
		display: flex;
		justify-content: space-between;
		margin-top: $gap-5;
	}

	.section-left {
		width: 20%;
		padding: $gap-5;
		display: flex;
		flex-direction: column;
	}

	.section-right {
		width: 60%;
		background-color: $color-accent-600;
		padding: $gap-5;
		margin-right: $gap-5;
		border-radius: 6px;
	}
}
</style>
